import { Skeleton, Typography } from "@packages/ds";
import styled from "styled-components";

import { Link as StyleLink, Button as StyleButton } from "ds/Button";
import * as Sticker from "ds/Sticker";
import * as Tabs from "ds/Tabs";

export const Container = styled.section`
  width: 100%;
  min-width: 65%;
  box-sizing: border-box;
  max-height: 1496px;
  overflow-y: auto;
  position: relative;
  border-radius: var(
    --activity-section-border-radius,
    var(--section-2px-border-radius, var(--2px))
  );
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BoxLayout = styled.div`
  padding: 0 32px;
`;

export const SubsectionHeading = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: var(--mode-text-neutral-default-weak);
`;

export const SubsectionHeadingFirst = styled(SubsectionHeading)`
  margin-top: -10px;
  color: var(--mode-text-neutral-default-weak);
`;

export const ActivityCount = styled.span`
  font-size: 13px;
  color: var(--mode-text-neutral-weakest);
`;

export const SectionFooter = styled.footer`
  padding: 10px;
  text-align: center;
`;

export const LinkButton = styled.button`
  background: transparent;
  cursor: pointer;
  padding: 6px 8px;
  height: auto;
  border: none;
  color: var(--button-color-primary-600-color, var(--color-primary-600));
  font-size: 14px;

  &:hover,
  &:focus {
    background: transparent;
    text-decoration: underline;
  }

  &:disabled,
  &[disabled] {
    color: var(--button-periwinkle-grey-color, var(--periwinkle-grey));
    text-decoration: none;
  }
`;

export const Row = styled(Skeleton.Card)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Layout = styled(Skeleton)`
  :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const ActivityHeader = styled.div<{ $isOnScroll?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  background-color: ${props =>
    props.$isOnScroll ? "var(--mode-bg-neutral-weakest)" : "none"};
  padding: ${props => (props.$isOnScroll ? "16px" : "none")};
  box-shadow: ${props =>
    props.$isOnScroll ? "0px 6px 24px 0px var(--mode-shadow-default)" : "none"};
  transition: 0.4s all;
  border-radius: var(
    --activity-section-border-radius,
    var(--section-2px-border-radius, var(--2px))
  );
`;

export const Header = styled.header`
  display: flex;
`;

export const ActivityTitle = styled(Typography.Title)`
  color: var(--mode-text-neutral-default);
  line-height: 18px;
`;

export const Tablist = styled.div`
  font-weight: 600;
  font-size: 13px;
  line-height: 1.8;
  flex-grow: 1;
`;

export const CustomTab = styled(Tabs.Trigger)`
  &[data-orientation="horizontal"] {
    display: inline-block;
    margin-left: 32px;

    &::before {
      content: "";
      display: inline-block;
      width: 100%;
      position: absolute;
      bottom: -4px;
      left: 0;
      height: 2px;
    }
    &:last-child {
      margin-left: 0;
    }
    &:active,
    &:hover,
    &:focus {
      position: relative;
      outline: none;

      &::before {
        content: "";
        display: inline-block;
        width: 100%;
        position: absolute;
        bottom: -4px;
        left: 0;
        height: 2px;
      }
    }
  }
`;

export const StickerRoot = styled(Sticker.Root)`
  margin-bottom: 15px;
`;

export const StickerText = styled(Sticker.Text)`
  display: block;
`;
export const Button = styled(StyleButton)`
  font-weight: inherit;
  font-size: inherit;
`;
export const Link = styled(StyleLink)`
  line-break: strict;
  font-size: inherit;
  font-weight: inherit;
`;

export const InfoButtonWrapper = styled.div`
  @media (max-width: 900px) {
    display: none;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;
